module.exports = __webpack_public_path__ + "img/finished-project.c05ddf7e.png";